import axios from '@/axios';

const RESOURCE_NAME = '/admin/keywords-whitelist';

export default {

    getKeywords(data) {
        return axios.post(`${RESOURCE_NAME}/get-keywords-index`, data)
    },

    delete(id) {
        return axios.post(`${RESOURCE_NAME}/delete-keyword?id=${id}`)
    },

    add(data) {
        return axios.post(`${RESOURCE_NAME}/add`, data)
    },
}
